import { Button, Cell, Grid } from 'react-md'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import React, { Component } from 'react'

import { TextField, ThumbnailImage } from 'components'
import { UserRole } from 'api/enums'
import { minLength, maxLength, required, email } from 'lib/validation'
import { getShopifySmartCollectionURL } from 'lib/uri'

import './index.css'

const minLength2 = minLength(2)
const minLength20 = minLength(20)
const maxLength15 = maxLength(15)
const maxLength30 = maxLength(30)

class ViewContent extends Component {
  render () {
    const {
      readOnly,
      form,
      initialValues,
      editPasswordRoute,
      handleUpload,
      uploadStatus,
      profileUrl
    } = this.props

    const profileURL =
      getShopifySmartCollectionURL(initialValues.shopifyCollectionHandle)

    return (
      <Grid noSpacing className='profile-view'>

        <Cell desktopSize={2} tabletSize={12} className='profile-image'>
          <ThumbnailImage
            className='md-cell--top'
            image={profileUrl}
            onUpload={handleUpload}
            progress={uploadStatus.progress}
            status={uploadStatus.status}
          />
        </Cell>

        <Cell size={6}>
          <Grid className='content'>

            <Cell desktopSize={5} size={4}>
              <Field
                id={`${form}-firstName`}
                name='firstName'
                label='First Name'
                component={TextField}
                validate={[ required, minLength2, maxLength15 ]}
                disabled={readOnly}
                required
              />
            </Cell>

            <Cell desktopSize={5} size={4}>
              <Field
                id={`${form}-lastName`}
                name='lastName'
                label='Last Name'
                component={TextField}
                disabled={readOnly}
                validate={[ required, minLength2, maxLength15 ]}
                required
              />
            </Cell>

            <Cell desktopSize={10} size={8}>
              <Field
                id={`${form}-email`}
                name='email'
                label='Email'
                component={TextField}
                validate={[ required ]}
                disabled
                required
              />
            </Cell>

            <Cell size={12}>
              <div className='md-caption'>
                Password
              </div>
              <Button
                raised
                swapTheming
                component={Link}
                to={editPasswordRoute}
              >
                Update password
              </Button>
            </Cell>

            { initialValues.role === UserRole.ARTIST && (
              <Cell desktopSize={8} size={6}>
                <Field
                  id={`${form}-artisticName`}
                  name='artisticName'
                  label='Artist Name'
                  component={TextField}
                  validate={[ required, minLength2, maxLength30 ]}
                  disabled
                  required
                />
              </Cell>
            ) }

            { initialValues.role === UserRole.ARTIST && (
              <Cell size={12}>
                <Field
                  id={`${form}-bio`}
                  name='bio'
                  label='Biography'
                  component={TextField}
                  validate={[ minLength20 ]}
                  rows={1}
                  maxRows={4}
                />
              </Cell>
            ) }

            { initialValues.role === UserRole.ARTIST && (
              <Cell size={12}>
                <div className='md-caption'>
                  My Store URL
                </div>
                <Link to={profileURL} target='_blank'>
                  { profileURL }
                </Link>
              </Cell>
            ) }

            { initialValues.role === UserRole.ARTIST && (
              <Cell desktopSize={10} size={8}>
                <Field
                  id={`${form}-paypal`}
                  name='paypal'
                  label='Paypal email'
                  component={TextField}
                  validate={[ email ]}
                />
              </Cell>
            ) }

          </Grid>
        </Cell>

      </Grid>
    )
  }
}

export default reduxForm({
  form: 'user-details',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(ViewContent)



// WEBPACK FOOTER //
// ./src/containers/User/View/ViewContent/index.js